import Immutable from "seamless-immutable";
import { groupBy } from "lodash";
import Support from "../types/Support";
import { REHYDRATION_COMPLETE, APP_ERROR } from "../types/App";

// Create initial Redux State for "user"
const INITIAL_STATE = Immutable({
  categories: {
    isFetching: false,
    results: [],
  },
  sections: {
    isFetching: false,
    // All sections keyed by their ID
    // This is for the section landing page for easy access
    results: {},
    // key = category_id
    // value = array of sections
    byCategory: {},
  },
  articles: {
    isFetching: false,
    // All articles keyed by their ID
    // This is for the article detail page for easy access
    results: {},
    // key = section_id
    // value = array of articles
    bySection: {},
  },
  // For Article Detail Page
  article: {
    isFetching: false,
    data: {},
  },
  // For Section Landing Page
  section: {
    isFetching: false,
    data: {},
  },
  search: {
    query: null,
    previousQuery: null,
    isFetching: false,
    data: {},
  },
});

const setTrueFetchingState = (state, key) => {
  return Immutable.updateIn(state, [key, "isFetching"], () => true);
};

const SupportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Support.FETCH_ALL_SUPPORT_DATA_RECEIVE:
      const { categories, sections, articles } = action;
      // Always update since there could be copy changes, small minor updates, etc.
      // thus making it expensive to compare persisted data with incoming
      return state.merge({
        categories: {
          isFetching: false,
          results: categories.categories,
        },
        sections: {
          isFetching: false,
          byCategory: groupBy(sections.sections, "category_id"),
        },
        articles: {
          isFetching: false,
          bySection: groupBy(articles.articles, "section_id"),
        },
      });
    case Support.FETCH_ALL_SUPPORT_DATA_REQUEST:
      return state.merge(
        {
          categories: { isFetching: true },
          sections: { isFetching: true },
          articles: { isFetching: true },
        },
        { deep: true }
      );
    case Support.STORE_SUPPORT_SEARCH_QUERY:
      return Immutable.updateIn(state, ["search", "query"], () => action.query);
    case Support.RESET_SECTION_DETAIL_DATA:
      return Immutable.updateIn(state, ["section", "data"], () => ({}));
    case Support.RESET_ARTICLE_DETAIL_DATA:
      return Immutable.updateIn(state, ["article", "data"], () => ({}));
    case APP_ERROR:
      return state.merge({
        categories: { isFetching: false },
        sections: { isFetching: false },
        articles: { isFetching: false },
        article: { isFetching: false },
        search: { isFetching: false },
      });
    case Support.FETCH_SUPPORT_SECTION_DETAIL_RECEIVE:
      return state.merge({
        section: {
          isFetching: false,
          data: action.section,
        },
      });
    case Support.NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE:
      return state.merge({
        search: {
          query: state.search.query,
          previousQuery: state.search.query,
          isFetching: false,
          data: action.results,
        },
      });
    case Support.FETCH_SUPPORT_ARTICLE_DETAIL_RECEIVE:
      return state.merge({
        article: {
          isFetching: false,
          data: action.article,
        },
      });
    case Support.FETCH_SUPPORT_SECTION_DETAIL_REQUEST:
      return setTrueFetchingState(state, "section");
    case Support.FETCH_SUPPORT_ARTICLE_DETAIL_REQUEST:
      return setTrueFetchingState(state, "article");
    case Support.NEW_SEARCH_SUPPORT_ARTICLES_REQUEST:
      return setTrueFetchingState(state, "search");
    case REHYDRATION_COMPLETE:
    default:
      return INITIAL_STATE.merge(state, { deep: true });
  }
};

export default SupportReducer;
